import { Tooltip } from 'antd';
import { useMemo } from 'react';
import { datetime } from '../../../../util/library/datetime';
import { durationTxt } from '../../../../util/varibles/global';
import { TOperation } from "../../../../util/varibles/interface";

interface IProps {
    data: TOperation
}

const EtaOperation: React.FC<IProps> = ({ data }) => {
    const { eta } = data;

    const { time, step } = eta || {};
    const value = useMemo(() => {
        switch (step) {
            case "running":
                return `Estimated arrival at site: ${datetime(time).format('DD/MM, HH:mm')}`;
            case "stop":
                return `has been stationary for ${time ? durationTxt(time) : ""}`;
            default:
                return "";
        }
    }, [step, time]);

    if (!eta) return null;

    return <Tooltip title={value}>
        <div className='text-[var(--colorActive)] italic'>
            {value}
        </div>
    </Tooltip>;
}

export default EtaOperation;